export function replaceSpacesWithDash(text: string): string {
  if (!text) {
    return text;
  }

  return text.replace(/ /g, '-');
}
